import VisualizeVocabulary from '../components/course/visualize-vocabulary';
<template><VisualizeVocabulary @model={{@model}} /></template>
